import {AfterViewInit, Component, ComponentFactoryResolver, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {NgElement} from "@angular/elements";
import {
  EmbeddedFieldAutoUpdateFunction,
  EmbeddedFieldCallbackFunction,
  EmbeddedFieldModel
} from "../../models/embedded-field/embedded-field.model";
import {UtilService} from "../../services/util/util.service";

@Component({
  selector: 'sb-knockout-form-wrapper',
  templateUrl: './knockout-form-wrapper.component.html',
  styleUrls: ['./knockout-form-wrapper.component.scss']
})
export class KnockoutFormWrapperComponent implements EmbeddedFieldModel, OnInit, AfterViewInit {

  @Input()
  title: string;

  @Input()
  component: string;

  @Input()
  rendererProperties: any = {};

  @Input()
  wrappedProperties: any = {};

  nestedElement: EmbeddedFieldModel;

  visible = true;

  @ViewChild('wrapper', {static: false}) wrapper?: ElementRef;

  @Input()
  initAngularComponent: EmbeddedFieldCallbackFunction;

  @Input()
  updateAngularComponent: EmbeddedFieldCallbackFunction;

  @Input()
  autoUpdateAngularComponent: EmbeddedFieldAutoUpdateFunction;

  @Input()
  showAngularComponent: EmbeddedFieldCallbackFunction;

  @Input()
  hideAngularComponent: EmbeddedFieldCallbackFunction;

  constructor(private resolver: ComponentFactoryResolver, private utilService: UtilService) {

    // Build update method that binds 'this' to the correct value. If 'update' is called from another
    // context, e.g. Knockout calling a method on a web component, 'this' will be the HTMLElement
    // not the Angular component unless we do this bind.
    const that = this;

    // Delegate update calls from a form to the nested component

    this.initAngularComponent = (current: any, eventName?: string, eventContext?: any) => {
      if (that?.nestedElement?.updateAngularComponent) {
        that.nestedElement.initAngularComponent(current, eventName, eventContext);
      }
    };

    this.updateAngularComponent = (current: any, eventName?: any, eventContext?: any) => {
      if (that?.nestedElement?.updateAngularComponent) {
        that.nestedElement.updateAngularComponent(current, eventName, eventContext);
      }
    };

    this.autoUpdateAngularComponent = () => {
      return that?.nestedElement?.autoUpdateAngularComponent ? that.nestedElement.autoUpdateAngularComponent() : true;
    }

    // Show and hide the wrapper directly

    this.showAngularComponent = (current: any, eventName?: any, eventContext?: any) => {
      if (!that.visible) {
        that.visible = true;
        that.utilService.tickThen(() => {
          this.redisplay();
        })
      }
    };

    this.hideAngularComponent = (current: any, eventName?: any, eventContext?: any) => {
      that.visible = false;
      that.nestedElement = null;
    };

  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    if (this.visible) {
      this.redisplay();
    }
  }

  redisplay() {
    if (this.component) {
      const element =  document.createElement(this.component) as NgElement;
      this.nestedElement = element as unknown as EmbeddedFieldModel;

      Object.getOwnPropertyNames(this.wrappedProperties).forEach(k => {
        element[k] = this.wrappedProperties[k];
      });

      element['rendererProperties'] = this.wrappedProperties;

      this.wrapper.nativeElement.appendChild(element);
    }

  }
}
